import React from 'react';
import { ORIENTATION_INSTRUCTIONS } from '../../utils/TrainingHelpers';

const ICONS = {
    front: '🔆',
    left: '⬅️',
    right: '➡️',
    slow: '🐢',
    fast: '🏎️',
    close: '🔍',
    far: '🌌'
};

const ReplacementPopup = ({ visible, orientations, onCancel, onConfirm }) => {
    if (!visible) return null;

    return (
        <div className="replacement-popup-overlay">
            <div className="replacement-popup">
                <h4>Record Additional Clips</h4>
                <ul className="replacement-list">
                    {orientations.map(o => (
                        <li key={o.orientation}>
                            <span className="orientation-label">
                                {ICONS[o.orientation] || ''} {ORIENTATION_INSTRUCTIONS[o.orientation]}
                            </span>
                            <span className="orientation-count">x{o.count}</span>
                        </li>
                    ))}
                </ul>
                <div className="replacement-buttons">
                    <button onClick={onCancel}>Cancel</button>
                    <button onClick={onConfirm}>OK</button>
                </div>
            </div>
        </div>
    );
};

export default ReplacementPopup;
